var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"overtile mx-auto rounded-0",attrs:{"color":"#37383A","dark":"","outlined":_vm.getOutlined}},[_c('v-img',{attrs:{"src":_vm.quote.img.url}},[_c('div',{staticClass:"fill-height bottom-gradient"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }